import { httpClient } from "@/services/http/client";

export type SubscriptionPlanPrice = {
  id: string;
  currency: string;
  amount: number;
  gateway: "razorpay" | "stripe";
};

export type SubscriptionPlan = {
  id: string;
  slug: string;
  title: string;
  description: string | null;
  interval: "monthly" | "annual";
  includesAllCourses: boolean;
  prices: SubscriptionPlanPrice[];
  courseIds: string[];
};

export async function fetchSubscriptionPlans(): Promise<SubscriptionPlan[]> {
  const res = await httpClient.get<{ data: { plans: SubscriptionPlan[] } }>(
    "/v1/subscriptions/plans",
  );
  return res.data.data.plans;
}
